import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';

@Component({
  selector: 'mh-dashboard-widget-card',
  standalone: true,
  imports: [SharedModule],
  template: `
    @if (ready()) {
      <div class="tw-flex-1 tw-flex tw-flex-col tw-min-h-0">
        <ng-content />
      </div>
    } @else {
      <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center">
        <mh-core-lib-loader-wrapper [loading]="true" [type]="'spinner'"></mh-core-lib-loader-wrapper>
      </div>
    }
  `,
  host: {
    class:
      'tw-flex tw-h-44 tw-w-full tw-flex-col tw-rounded-lg tw-bg-white tw-p-5 tw-shadow-md',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardWidgetCardComponent {
  ready = input.required<boolean>();
}
